export default "__VITE_ASSET__Col5h4ZL__"